import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./Pages/Home";
import Footer from "./Components/Footer";
import Services from "./Pages/Services";
import SignUp from "./Pages/SignUp";
import Category from "./Pages/Category";
import Location from "./Pages/Location";
import Blogs from "./Pages/Blogs";
import Contact from "./Pages/Contact";
import SignIn from "./Pages/SignIn";
import BlogById from "./Pages/BlogById";
import ServicesByCategory from "./Pages/ServiceByCategory";
import ProviderSignUp from "./Pages/ProviderSignUp";
import DashboardLayout from "./Pages/dashboard/Layout";
import DashboardHome from "./Pages/dashboard/Home";
import DashboardProviders from "./Pages/dashboard/Providers";
import DashboardCustomers from "./Pages/dashboard/Customers";
import DashboardListings from "./Pages/dashboard/Listings";
import DashboardSettings from "./Pages/dashboard/Settings";
import ProviderLayout from "./Pages/provider/Layout";
import ProviderHome from "./Pages/provider/Home";
import ProviderListings from "./Pages/provider/Listings";
import ProviderCreate from "./Pages/provider/Create";
import ProviderProfile from "./Pages/provider/Profile";
// import PromoterSignUp from "./Pages/PromoterSignUp"; // Removed - promoters created by channel partners
// import Navbar from "./Components/Navbar";
import {
  RoleRoute,
  GuestRoute,
  ProtectedRoute,
} from "./Components/ProtectedRoute";
import ServiceByLocation from "./Pages/ServiceByLocation";
import About from "./Pages/About";
import ScrollToTop from "./Components/ScrollToTop";
import ProviderProfileById from "./Pages/ProviderProfileById";
import ChannelPartnerLayout from "./Pages/ChannelPartner/Layout";
import ChannelPartnerHome from "./Pages/ChannelPartner/Home";
import ChannelPartnerPromoters from "./Pages/ChannelPartner/Promoter";
import ChannelPartnerListings from "./Pages/ChannelPartner/Listings";
import ChannelPartnerProviders from "./Pages/ChannelPartner/Providers";
import ChannelPartnerProfile from "./Pages/ChannelPartner/Profile";
import CreatePromoter from "./Pages/ChannelPartner/CreatePromoter";
import CreateChannelPartner from "./Pages/dashboard/CreateChannelPartner";
import ChannelPartners from "./Pages/dashboard/ChannelPartners";
import Promoters from "./Pages/dashboard/Promoters";
import PromoterLayout from "./Pages/Promoter/Layout";
import PromoterHome from "./Pages/Promoter/Home";
import PromoterProviders from "./Pages/Promoter/Providers";
import PromoterListings from "./Pages/Promoter/Listings";
import PromoterProfile from "./Pages/Promoter/Profile";
import CreateProviderSimple from "./Pages/Promoter/CreateProviderSimple";
import IdCard from "./Pages/Promoter/IdCard";
import Enquiry from "./Pages/dashboard/Enquiry";
import Certificate from "./Pages/provider/Certificate";
import EnquiryForm from "./Pages/EnquiryForm";

export default function App() {
  const location = useLocation();
  const isDashboard =
    location.pathname.startsWith("/dashboard") ||
    location.pathname.startsWith("/provider") ||
    location.pathname.startsWith("/channelpartner") ||
    location.pathname.startsWith("/promoter");
  return (
    <div className="App">
      {/* <Navbar /> */}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/categories" element={<Category />} />
        <Route path=":id" element={<ProviderProfileById />} />
        <Route path="/enquiryform" element={<EnquiryForm/>} />

        <Route element={<GuestRoute />}>
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/provider/signup" element={<ProviderSignUp />} />
        </Route>

        {/* Provider signup for promoters (authenticated users) */}
        <Route element={<ProtectedRoute />}>
          <Route
            path="/promoter/provider-signup"
            element={<CreateProviderSimple />}
          />
        </Route>
        <Route path="/locations" element={<Location />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        {/* <Route path="/promoter" element={<PromoterSignUp />} /> - Removed: promoters created by channel partners */}

        <Route element={<RoleRoute role="provider" />}>
          <Route path="/provider" element={<ProviderLayout />}>
            <Route index element={<ProviderHome />} />
            <Route path="listings" element={<ProviderListings />} />
            <Route path="create" element={<ProviderCreate />} />
            <Route path="certificate" element={<Certificate />} />
            <Route path="profile" element={<ProviderProfile />} />
          </Route>
        </Route>
        <Route element={<RoleRoute role="admin" />}>
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardHome />} />
            <Route path="channel-partners" element={<ChannelPartners />} />
            <Route path="promoters" element={<Promoters />} />
            <Route path="providers" element={<DashboardProviders />} />
            <Route path="customers" element={<DashboardCustomers />} />
            <Route path="listings" element={<DashboardListings />} />
            <Route path="enquiry" element={<Enquiry />} />

            <Route
              path="create-channel-partner"
              element={<CreateChannelPartner />}
            />
            <Route path="settings" element={<DashboardSettings />} />
          </Route>
        </Route>

        <Route element={<RoleRoute role="channel_partner" />}>
          <Route path="/channelpartner" element={<ChannelPartnerLayout />}>
            <Route index element={<ChannelPartnerHome />} />
            <Route path="dashboard" element={<ChannelPartnerHome />} />
            <Route path="promoters" element={<ChannelPartnerPromoters />} />
            <Route path="create-promoter" element={<CreatePromoter />} />
            <Route path="listings" element={<ChannelPartnerListings />} />
            <Route path="providers" element={<ChannelPartnerProviders />} />
            {/* <Route path="certificate" element={<Certificate />} /> */}
            <Route path="profile" element={<ChannelPartnerProfile />} />
          </Route>
        </Route>

        <Route element={<RoleRoute role="promoter" />}>
          <Route path="/promoter" element={<PromoterLayout />}>
            <Route index element={<PromoterHome />} />
            <Route path="dashboard" element={<PromoterHome />} />
            <Route path="providers" element={<PromoterProviders />} />
            <Route path="listings" element={<PromoterListings />} />
            <Route path="profile" element={<PromoterProfile />} />
            <Route path="idcard" element={<IdCard />} />
          </Route>
        </Route>

        <Route path="/blogs/:id" element={<BlogById />} />
        <Route
          path="/services/category/:categoryId"
          element={<ServicesByCategory />}
        />
        <Route path="/services/location" element={<ServiceByLocation />} />
      </Routes>
      {!isDashboard && <Footer />}
    </div>
  );
}
